export default __webpack_public_path__ + "static/media/Letter H.31d88ab9.mov";